import React, { useEffect } from 'react';
import type { RouteObject } from 'react-router-dom';
import authService from '../auth/auth-service';

function LogoutRoute(): null {
  useEffect(() => {
    authService.logout();
  }, []);
  return null;
}

const logoutRoutes: RouteObject[] = [
  {
    path: '/logout',
    element: <LogoutRoute />,
    handle: { crumb: () => ({ label: 'Logout' }) },
  },
];

export default logoutRoutes;
